import { SortKey } from "./SortingDropdown";
import { stringComparator, decimalComparator, datetimeComparator, numberComparator } from "@goodfill/sort";
import { PricedBond } from "../../PricedBond";
import { getBondRatingIndicesWithOffsetForMissingRating } from "../../bondRating/getBondRatingIndicesWithOffsetForMissingRating";

type Comparator = (a: PricedBond, b: PricedBond) => number;

type ComparatorMap = {
  [Property in SortKey]: Comparator;
};

export const pricedBondsComparators: ComparatorMap = {
  issuer: (a, b) => stringComparator(`${a.issuerName}`, `${b.issuerName}`),
  ticker: (a, b) => stringComparator(`${a.issuerTicker}`, `${b.issuerTicker}`),
  coupon: (a, b) => decimalComparator(a.couponPayment, b.couponPayment),
  maturity: (a, b) => datetimeComparator(a.maturityDate, b.maturityDate),
  price: (a, b) => decimalComparator(a.askPrice, b.askPrice),
  offerYield: (a, b) => decimalComparator(a.askYield, b.askYield),
  amount: (a, b) => decimalComparator(a.minimumPiece.amount, b.minimumPiece.amount),
  "payment-rank": (a, b) => stringComparator(a.paymentRank, b.paymentRank),
  // we don't need G-Spread Bid right now
  "g-spread": (a, b) => decimalComparator(a.askGSpread, b.askGSpread),
  "rating-sp": (a, b) => {
    const aIndex = getBondRatingIndicesWithOffsetForMissingRating(a).spIndex;
    const bIndex = getBondRatingIndicesWithOffsetForMissingRating(b).spIndex;

    return numberComparator(aIndex, bIndex);
  },
  "rating-moody": (a, b) => {
    const aIndex = getBondRatingIndicesWithOffsetForMissingRating(a).moodysIndex;
    const bIndex = getBondRatingIndicesWithOffsetForMissingRating(b).moodysIndex;

    return numberComparator(aIndex, bIndex);
  },
};

export type BondSortDirection = "ASC" | "DESC";

export function sortBondList(pricedBonds: PricedBond[], sortKey: SortKey, direction: BondSortDirection): PricedBond[] {
  const comparator = pricedBondsComparators[sortKey];

  return [...pricedBonds].sort((a: PricedBond, b: PricedBond) => {
    const compResult = comparator(a, b);
    if (compResult !== 0) {
      return direction === "ASC" ? compResult : -compResult;
    }

    return 0;
  });
}
